
import { UserApi } from '@/api';
import { pageRoutes } from '@/components/routes';
import React, { createContext, useContext, useState, ReactNode, useEffect } from 'react';

interface IUser {
    user: IUserContext | null;
    isIndo?: boolean;
    // setUser: (user: IUserContext | null) => void;
}
// Create a context
const UserContext = createContext<IUser | null>(null);

// Create a provider component
export const UserProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const [user,setUser] = useState<IUserContext | null>( window.user); // Initialize user state
    const [isIndo,setIsIndo] = useState(false);

    useEffect(() => {
        if(user?.country_id == "5"){
            setIsIndo(true);
        }
        if (user?.user_login==null || typeof(user?.user_login) === 'undefined') {
            window.location.href = user?.login_url||"/";
        } else {
            UserApi.getUserWorkspaces().then((res) => {
                var newUser = {...user,...res};
                // console.log(newUser);
                setUser(newUser);
            }).catch((err) => {
                console.error("Error in get user workspaces:", err);
            });
        }
    }, []);

    return (
        <UserContext.Provider value={{ user, isIndo }}>
            {children}
        </UserContext.Provider>
    );
};

// Custom hook to use the UserContext
export const useUser = () => {
    const context = useContext(UserContext);
    if (!context) {
        throw new Error('useUser must be used within a UserProvider');
    }
    return context;
};